var _a;
import { Interaction_Modality_Code } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Interaction_Modality_Code.AnnualPhysicalForm] = 'Annual physical form',
    _a[Interaction_Modality_Code.Appointment] = 'Appointment',
    _a[Interaction_Modality_Code.CarePlan] = 'Care plan',
    _a[Interaction_Modality_Code.Chat] = 'Chat',
    _a[Interaction_Modality_Code.Claim] = 'Claim',
    _a[Interaction_Modality_Code.Common] = 'Common',
    _a[Interaction_Modality_Code.DiabetesProgram] = 'Diabetes program',
    _a[Interaction_Modality_Code.Email] = 'Email',
    _a[Interaction_Modality_Code.Fax] = 'Fax',
    _a[Interaction_Modality_Code.FinancialDataValue] = 'Financial data value',
    _a[Interaction_Modality_Code.Internal] = 'Internal',
    _a[Interaction_Modality_Code.Mail] = 'Mail',
    _a[Interaction_Modality_Code.MailOrderTransfer] = 'Mail order transfer',
    _a[Interaction_Modality_Code.MedicalNavigation] = 'Medical navigation',
    _a[Interaction_Modality_Code.Other] = 'Other',
    _a[Interaction_Modality_Code.Override] = 'Override',
    _a[Interaction_Modality_Code.Phonecall] = 'Phonecall',
    _a[Interaction_Modality_Code.PriorAuthorization] = 'Prior authorization',
    _a[Interaction_Modality_Code.ProactiveDrug] = 'Proactive drug',
    _a[Interaction_Modality_Code.ScheduledFollowUp] = 'Scheduled follow up',
    _a[Interaction_Modality_Code.SeldonBeattieForm] = 'Seldon beattie form',
    _a[Interaction_Modality_Code.TextMessage] = 'Text message',
    _a[Interaction_Modality_Code.BenefitInquiry] = 'Benefit inquiry',
    _a[Interaction_Modality_Code.PriorAuthorizationStatus] = 'Prior authorization status',
    _a[Interaction_Modality_Code.DrugListUpdateRequest] = 'Drug list update request',
    _a[Interaction_Modality_Code.WeightManagementProgram] = 'Weight management program',
    _a[Interaction_Modality_Code.AccumulatorIssue] = 'Accumulator issue',
    _a[Interaction_Modality_Code.VendorSetup] = 'Vendor setup',
    _a[Interaction_Modality_Code.NewImplementation] = 'New implementation',
    _a[Interaction_Modality_Code.GroupTerming] = 'Group terming',
    _a[Interaction_Modality_Code.ClaimFileProcessings] = 'Claim file processing',
    _a[Interaction_Modality_Code.AccumulatorChange] = 'Accumulator change',
    _a[Interaction_Modality_Code.FertilityMaximum] = 'Fertility maximum',
    _a[Interaction_Modality_Code.GroupNumberChange] = 'Group number change',
    _a[Interaction_Modality_Code.PlanChangeHandling] = 'Plan change handling',
    _a[Interaction_Modality_Code.ImpactReport] = 'Impact report',
    _a[Interaction_Modality_Code.EligibilityInquiry] = 'Eligibility inquiry',
    _a);
export var InteractionModalityCodeEnum = {
    name: 'Interaction_Modality_Code',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
